var Opal = require('../opal').default; /* Generated by Opal 0.11.99.dev */
(function(Opal) {
  function $rb_divide(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs / rhs : lhs['$/'](rhs);
  }
  function $rb_times(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs * rhs : lhs['$*'](rhs);
  }
  function $rb_ge(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs >= rhs : lhs['$>='](rhs);
  }
  var self = Opal.top, $nesting = [], nil = Opal.nil, $$$ = Opal.const_get_qualified, $$ = Opal.const_get_relative, $breaker = Opal.breaker, $slice = Opal.slice, $klass = Opal.klass, $send = Opal.send, $truthy = Opal.truthy, $gvars = Opal.gvars;

  Opal.add_stubs(['$=~', '$gsub', '$debug', '$/', '$*', '$>=', '$==']);
  return (function($base, $super, $parent_nesting) {
    var self = $klass($base, $super, 'ShadowRun4');

    var $nesting = [self].concat($parent_nesting), $ShadowRun4_initialize$1, $ShadowRun4_gameName$2, $ShadowRun4_gameType$3, $ShadowRun4_getHelpMessage$4, $ShadowRun4_changeText$5, $ShadowRun4_getGrichText$7;

    
    
    Opal.def(self, '$initialize', $ShadowRun4_initialize$1 = function $$initialize() {
      var $iter = $ShadowRun4_initialize$1.$$p, $yield = $iter || nil, self = this, $zuper = nil, $zuper_i = nil, $zuper_ii = nil;

      if ($iter) $ShadowRun4_initialize$1.$$p = null;
      // Prepare super implicit arguments
      for($zuper_i = 0, $zuper_ii = arguments.length, $zuper = new Array($zuper_ii); $zuper_i < $zuper_ii; $zuper_i++) {
        $zuper[$zuper_i] = arguments[$zuper_i];
      }
      
      $send(self, Opal.find_super_dispatcher(self, 'initialize', $ShadowRun4_initialize$1, false), $zuper, $iter);
      self.sortType = 3;
      self.rerollNumber = 6;
      return (self.defaultSuccessTarget = ">=5");
    }, $ShadowRun4_initialize$1.$$arity = 0);
    
    Opal.def(self, '$gameName', $ShadowRun4_gameName$2 = function $$gameName() {
      var self = this;

      return "シャドウラン第４版"
    }, $ShadowRun4_gameName$2.$$arity = 0);
    
    Opal.def(self, '$gameType', $ShadowRun4_gameType$3 = function $$gameType() {
      var self = this;

      return "ShadowRun4"
    }, $ShadowRun4_gameType$3.$$arity = 0);
    
    Opal.def(self, '$getHelpMessage', $ShadowRun4_getHelpMessage$4 = function $$getHelpMessage() {
      var self = this;

      return "" + "個数振り足しロール(xRn)の境界値を6にセット、バラバラロール(xBn)の目標値を5以上にセットします。\n" + "BコマンドとRコマンド時に、グリッチの表示を行います。\n"
    }, $ShadowRun4_getHelpMessage$4.$$arity = 0);
    
    Opal.def(self, '$changeText', $ShadowRun4_changeText$5 = function $$changeText(string) {
      var $a, $$6, self = this, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil;

      
      if ($truthy(string['$=~'](/(\d+)S6/i))) {
        
        __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
        __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
        __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
        __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
        __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
        __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
        __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
        __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
        __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
        __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
        __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
        __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
        __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
        __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
        __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
        __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
        __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
        __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
        __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
        __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
        string = $send(string, 'gsub', [/(\d+)S6/i], ($$6 = function(){var self = $$6.$$s || this, $b;

        
          __last__match__1 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](1));
          __last__match__2 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](2));
          __last__match__3 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](3));
          __last__match__4 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](4));
          __last__match__5 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](5));
          __last__match__6 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](6));
          __last__match__7 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](7));
          __last__match__8 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](8));
          __last__match__9 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](9));
          __last__match__10 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](10));
          __last__match__11 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](11));
          __last__match__12 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](12));
          __last__match__13 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](13));
          __last__match__14 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](14));
          __last__match__15 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](15));
          __last__match__16 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](16));
          __last__match__17 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](17));
          __last__match__18 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](18));
          __last__match__19 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](19));
          __last__match__20 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](20));
          return "" + (__last__match__1) + "B6";}, $$6.$$s = self, $$6.$$arity = 0, $$6));};
      return string;
    }, $ShadowRun4_changeText$5.$$arity = 1);
    return (Opal.def(self, '$getGrichText', $ShadowRun4_getGrichText$7 = function $$getGrichText(numberSpot1, dice_cnt_total, successCount) {
      var self = this, dice_cnt_total_half = nil;

      
      self.$debug("getGrichText numberSpot1", numberSpot1);
      self.$debug("dice_cnt_total", dice_cnt_total);
      self.$debug("successCount", successCount);
      dice_cnt_total_half = $rb_divide($rb_times(1.0, dice_cnt_total), 2);
      self.$debug("dice_cnt_total_half", dice_cnt_total_half);
      if ($truthy($rb_ge(numberSpot1, dice_cnt_total_half))) {
      } else {
        return ""
      };
      if ($truthy(successCount['$=='](0))) {
        return " ＞ クリティカルグリッチ"};
      return " ＞ グリッチ";
    }, $ShadowRun4_getGrichText$7.$$arity = 3), nil) && 'getGrichText';
  })($nesting[0], $$($nesting, 'DiceBot'), $nesting)
})(Opal);
